module.exports = __webpack_public_path__ + "media/src/assets/Images/RealEstateClosedArrow-48b416c14cb36544e5dd860e7c51cdf8.svg";